export default {
    lang_choice_title: 'Добро пожаловать',
    lang_choice_subtitle: 'Выберите свой язык',

    more: 'Еще',
    show_more: 'Показать ещё',
    more_results: 'Показать больше результатов',
    loading: 'Загрузка',
    nofind_movie: 'Не удалось найти фильм.',
    noname: 'Без названия',
    nochoice: 'Не выбрано',
    cancel: 'Отменить',
    confirm: 'Подтверждаю',
    sure: 'Вы уверены?',
    nodata: 'Нет данных',
    back: 'Назад',
    ready: 'Готово',
    close_app_modal: 'Вы уверены, что хотите покинуть приложение?',
    connected_seeds: 'подкл.',

    search: 'Поиск',
    search_input: 'Введите текст',
    search_empty: 'История поиска пуста.',
    search_delete: 'Влево - удалить',
    search_start_typing: 'Начните вводить текст для поиска.',
    search_searching: 'Идет поиск...',
    search_start: 'Начать поиск',
    search_nofound: 'По вашему запросу ничего не найдено.',

    full_genre: 'Жанр',
    full_production: 'Производство',
    full_date_of_release: 'Дата релиза',
    full_budget: 'Бюджет',
    full_countries: 'Страны',
    full_like: 'Нравится',
    full_torrents: 'Торренты',
    full_trailers: 'Трейлеры',
    full_detail: 'Подробно',
    full_notext: 'Без описания.',
    full_series_release: 'Выход серий',
    full_next_episode: 'Следующая',
    full_episode_days_left: 'Осталось дней',
    full_trailer_official: 'Официальный',
    full_trailer_no_official: 'Неофициальный',
    full_season: 'Cезон',
    full_episode: 'Эпизод',
    full_directing: 'Режиссура',
    full_writing: 'Сценарий',
    full_keywords: 'Теги',
    full_crew: 'Еще',
    full_editing: 'Монтаж',
    full_creator: 'Создатель',

    settings_cub_sync: 'Синхронизация',
    settings_cub_sync_descr: 'Синхронизация с сервисом CUB: синхронизация ваших закладок, истории просмотров, меток и тайм-кодов.',
    settings_cub_account: 'Аккаунт',
    settings_cub_logged_in_as: 'Вошли как',
    settings_cub_profile: 'Профиль',
    settings_cub_sync_btn: 'Синхронизировать',
    settings_cub_sync_btn_descr: 'Сохранить локальные закладки в аккаунт CUB',
    settings_cub_backup: 'Бэкап',
    settings_cub_backup_descr: 'Сохранить или загрузить бэкап данных',
    settings_cub_logout: 'Выйти из аккаунта',
    settings_cub_signin: 'Авторизация',
    settings_cub_not_specified: 'Не указан',
    settings_cub_password: 'Пароль',
    settings_cub_status: 'Статус',
    settings_cub_backup_import: 'Импорт',
    settings_cub_backup_export: 'Экспорт',
    settings_cub_backup_export_descr: 'Сохранить настройки в облако',
    settings_cub_backup_import_descr: 'Восстановить настройки из облака',
    settings_cub_sync_filters: 'Синхронизация фильтров',
    settings_cub_sync_calendar: 'Синхронизация календаря',
    settings_cub_sync_quality: 'Синхронизация отметок (качество)',
    settings_cub_sync_search: 'Синхронизация истории поиска',
    settings_cub_sync_recomends: 'Синхронизация рекомендаций',
    settings_cub_sync_timecodes: 'Синхронизация тайм-кодов',
    settings_cub_signin_button: 'Выполнить вход',
    settings_cub_domain: 'Основной домен',

    settings_input_links: 'Избранное',

    settings_interface_type: 'Облегчённая версия',
    settings_interface_size: 'Размер интерфейса',
	settings_interface_menu_always: 'Всегда показывать левое меню',
    settings_interface_background: 'Фон',
    settings_interface_background_use: 'Показывать фон',
    settings_interface_background_type: 'Тип фона',
    settings_interface_performance: 'Быстродействие',
    settings_interface_animation: 'Анимация',
    settings_interface_advanced_animation: 'Продвинутая анимация',
    settings_interface_animation_descr: 'Анимация карточек и контента',
    settings_interface_attenuation: 'Затухание',
    settings_interface_attenuation_descr: 'Плавное затухание карточек снизу и сверху',
    settings_interface_scroll: 'Тип скролинга',
    settings_interface_view_card: 'Тип просмотра карточек',
    settings_interface_view_card_descr: 'По мере скроллинга ленты карточки будут подгружаться постепенно или загружаться все',
    settings_interface_lang: 'Язык интерфейса',
    settings_interface_lang_reload: 'Необходимо перезапустить приложение, нажмите «OK» для перезагрузки',
    settings_interface_card_interfice: 'Интерфейс карточек',
    settings_interface_card_poster: 'Показать постер',
    settings_interface_card_cover: 'Показать обложку',
    settings_interface_card_reactions: 'Показать реакции',
    settings_interface_glass: 'Стекло',
    settings_interface_glass_descr: 'Показывать интерфейс в стекловидном стиле',
    settings_interface_glass_opacity: 'Прозрачность стекла',
    settings_interface_black_style: 'Чёрный стиль',
    settings_interface_hide_outside_the_screen: 'Скрывать карточки за пределами экрана',
    settings_interface_hide_outside_the_screen_descr: 'Это ускорит рендер интерфейса и улучшит производительность',

    settings_interface_sound: 'Системные звуки',
    settings_interface_sound_play: 'Переходы',
    settings_interface_sound_level: 'Уровень громкости',

    settings_main_account: 'Аккаунт',
    settings_main_interface: 'Интерфейс',
    settings_main_player: 'Плеер',
    settings_main_parser: 'Парсер',
    settings_main_torrserver: 'TorrServer',
    settings_main_plugins: 'Расширения',
    settings_main_rest: 'Остальное',

    settings_rest_start: 'Стартовая страница',
    settings_rest_start_descr: 'С какой страницы начинать при запуске',
    settings_rest_source: 'Источник',
    settings_rest_source_use: 'Основной источник',
    settings_rest_source_descr: 'Откуда брать информацию о фильмах',
    settings_rest_tmdb_lang: 'На каком языке отображать данные с TMDB',
    settings_rest_tmdb_prox: 'Проксировать TMDB',
    settings_rest_tmdb_prox_auto: 'Включить прокси автоматически',
    settings_rest_tmdb_posters: 'Разрешение постеров TMDB',
    settings_rest_screensaver: 'Скринсейвер',
    settings_rest_screensaver_use: 'Показывать заставку при бездействии',
    settings_rest_screensaver_type: 'Тип заставки',
    settings_rest_screensaver_time: 'Через сколько минут запустить скринсейвер',
    settings_rest_helper: 'Подсказки',
    settings_rest_helper_use: 'Показывать подсказки',
    settings_rest_helper_reset: 'Показать подсказки снова',
    settings_rest_pages: 'Сколько страниц хранить в памяти',
    settings_rest_pages_descr: 'Хранит страницы в том состоянии, в котором вы их покинули.',
    settings_rest_time: 'Сместить время',
    settings_rest_navigation: 'Тип навигации',
    settings_rest_keyboard: 'Тип клавиатуры',
    settings_rest_device: 'Название устройства',
    settings_rest_device_placeholder: 'Например: Моя Лампа',
    settings_rest_cache: 'Очистить кэш',
    settings_rest_tmdb_example: 'Например:',
    settings_rest_tmdb_api_descr: 'Для получения данных',
    settings_rest_tmdb_image_descr: 'Для получения изображений',
    settings_rest_card_quality: 'Отметки качества',
    settings_rest_card_quality_descr: 'Отображать отметки качества на карточках',
    settings_rest_card_episodes: 'Отметки эпизодов',
    settings_rest_card_episodes_descr: 'Отображать отметки эпизодов на карточках',
    settings_rest_cache_images: 'Кэш изображений',
    settings_rest_cache_images_descr: 'Кэшировать постеры и фоны в локальное хранилище',
    settings_rest_protocol_use: 'Безопасное соединение',
    settings_rest_protocol_descr: 'Использовать протокол HTTPS',
    settings_rest_cache_only: 'Только кеш',
    settings_rest_cache_only_descr: 'Основные настройки сохранятся',
    settings_rest_cache_all: 'Кеш и данные',
    settings_rest_cache_all_descr: 'Будут очищены все настройки и данные',
    settings_rest_cache_calculate: 'Сколько осталось памяти',
    settings_request_caching_use: 'Кэширование запросов',
    settings_request_caching_descr: 'Сохранять ответы от серверов в кэш для ускорения работы приложения',

    settings_parser_use: 'Использовать парсер',
    settings_parser_use_descr: 'Тем самым, вы соглашаетесь принять на себя всю ответственность за использование публичных ссылок для просмотра торрент и онлайн контента.',
    settings_parser_type: 'Тип парсера для торрентов',
    settings_parser_jackett_placeholder: 'Например: 192.168.х',
    settings_parser_jackett_link: 'Ссылка',
    settings_parser_jackett_link_descr: 'Укажите ссылку на скрипт Jackett',
    settings_parser_prowlarr_link_descr: 'Укажите ссылку на сервер Prowlarr',
    settings_parser_jackett_key_placeholder: 'Например: sa0sk83d..',
    settings_parser_jackett_key: 'Api-ключ',
    settings_parser_jackett_key_descr: 'Находится в Jackett',
    settings_parser_prowlarr_key_descr: 'Находится во вкладке настроек Prowlarr в категории основное',
    settings_parser_torlook_type: 'Метод парсинга сайта TorLook',
    settings_parser_scraperapi_placeholder: 'Например: scraperapi.com',
    settings_parser_scraperapi_link: 'Ссылка на парсер сайтов',
    settings_parser_scraperapi_descr: 'Зарегистрируйтесь на сайте scraperapi.com, введите ссылку api.scraperapi.com?api_key=...&url={q}<br>В {q} будет поставляться сайт w41.torlook.info',
    settings_parser_search: 'Поиск',
    settings_parser_search_descr: 'На каком языке производить поиск?',
    settings_parser_in_search: 'Парсер в поиске',
    settings_parser_in_search_descr: 'Показывать результаты в поиске?',
    settings_parser_timeout_title: 'Таймаут парсера',
    settings_parser_timeout_descr: 'Время (в секундах) ожидания ответа от сервера',

    settings_player_type: 'Тип плеера',
    settings_player_type_descr: 'Каким плеером воспроизводить видео',
    settings_player_iptv_type: 'Тип плеера для IPTV',
    settings_player_iptv_type_descr: 'Каким плеером воспроизводить IPTV-каналы',
    settings_player_torrent_type: 'Тип плеера для торрентов',
    settings_player_torrent_type_descr: 'Каким плеером воспроизводить торренты',
    settings_player_reset: 'Сбросить плеер по умолчанию',
    settings_player_reset_descr: 'Сбрасывает выбранный Android-плеер в приложении',
    settings_player_path: 'Путь к плееру',
    settings_player_path_descr: 'Укажите путь к исполняемому файлу плеера',
    settings_player_vlc_header: 'Настройки VLC',
    settings_player_vlc_api_password: 'Пароль VLC API',
    settings_player_vlc_api_password_descr: 'По-умолчанию: 123456',
    settings_player_vlc_fullscreen: 'Запускать в полноэкранном режиме',
    settings_player_normalization: 'Нормализация звука',
    settings_player_normalization_descr: 'Нормализирует звук в один уровень, понижает громкие звуки и повышает тихие.',
    settings_player_next_episode: 'Следующая серия',
    settings_player_next_episode_descr: 'Автоматически переключать на следующую серию по окончании текущей',
    settings_player_timecode: 'Тайм-код',
    settings_player_timecode_descr: 'Продолжить с последнего места просмотра',
    settings_player_scale: 'Метод масштабирования',
    settings_player_scale_descr: 'Каким образом производить вычисления для масштабирования видео',
    settings_player_subs: 'Субтитры',
    settings_player_subs_use: 'Включить',
    settings_player_subs_use_descr: 'Всегда включать субтитры после запуска видео',
    settings_player_subs_size: 'Размер',
    settings_player_subs_size_descr: 'Размер субтитров на экране',
    settings_player_subs_stroke_use: 'Использовать окантовку',
    settings_player_subs_stroke_use_descr: 'Субтитры будут обведены черным цветом для улучшения читаемости',
    settings_player_subs_backdrop_use: 'Использовать подложку',
    settings_player_subs_backdrop_use_descr: 'Субтитры будут отображаться на полупрозрачной подложке для улучшения читаемости',
    settings_player_quality: 'Качество видео по умолчанию',
    settings_player_quality_descr: 'Предпочтительное качество видео для просмотра',
    settings_player_hls_title: 'Обработка потока .m3u8',
    settings_player_hls_descr: 'Не трогайте этот параметр, если не знаете, зачем он.',
    settings_player_rewind_title: 'Перемотка',
    settings_player_rewind_descr: 'Интервал перемотки в секундах',
    settings_player_launch_trailers: 'Плеер для трейлеров',

    settings_plugins_notice: 'Для применения плагина необходимо перезагрузить приложение',
    settings_plugins_add: 'Добавить плагин',
    settings_plugins_add_descr: 'Для удаления добавленного плагина удерживайте или нажмите дважды клавишу (OK) на нем',
    settings_plugins_install: 'Установить плагин',
    settings_plugins_install_descr: 'Установить плагин из списка доступных',

    settings_server_link: 'Использовать ссылку',
    settings_server_links: 'Ссылки',
    settings_server_placeholder: 'Например: 192.168.х',
    settings_server_link_one: 'Основная ссылка',
    settings_server_link_one_descr: 'Укажите основную ссылку на TorrServer',
    settings_server_link_two: 'Дополнительная ссылка',
    settings_server_link_two_descr: 'Укажите дополнительную ссылку на TorrServer',
    settings_server_additionally: 'Дополнительно',
    settings_server_client: 'Встроенный клиент',
    settings_server_client_descr: 'Использовать встроенный JS-клиент TorrServer, иначе запускается системный.',
    settings_server_base: 'Сохранять в базу',
    settings_server_base_descr: 'Торрент будет добавлен в базу TorrServer',
    settings_server_preload: 'Использовать буфер пред.загрузки',
    settings_server_preload_descr: 'Дожидаться заполнения буфера предварительной загрузки TorrServer перед проигрыванием',
    settings_server_auth: 'Авторизация',
    settings_server_password_use: 'Вход по паролю',
    settings_server_login: 'Логин',
    settings_server_password: 'Пароль',
    settings_server_not_specified: 'Не указан',

    settings_webos_launcher: 'Запуск приложения',
    settings_webos_launcher_add_device: 'Установить как стартовое',
    settings_webos_launcher_remove_device: 'Убрать из стартовых приложений',

    settings_parental_control_param_time_always: 'Всегда',
    settings_parental_control_param_time_once: 'Один раз',
    settings_parental_control_param_time_10: 'Через 10 минут',
    settings_parental_control_param_time_20: 'Через 20 минут',
    settings_parental_control_param_time_30: 'Через 30 минут',
    settings_parental_control_param_time_60: 'Через 1 час',
    settings_parental_control_param_time_120: 'Через 2 часа',
    settings_parental_control_change_pin: 'Изменить PIN-код',
    settings_parental_control_demand_title: 'Когда запрашивать',
    settings_parental_control_demand_descr: 'Через какое время запрашивать PIN-код',
    settings_parental_control_enabled: 'Включено',
    settings_parental_control_disabled: 'Отключено',
    settings_parental_control_where: 'Где запрашивать PIN-код',

    settings_lgbt_content_block: 'Блокировать ЛГБТ контент',

    parental_control_input_new_code: 'Введите новый PIN-код',
    parental_control_confirm_new_code: 'Повторите PIN-код',
    parental_control_no_match_code: 'PIN-код не совпадает с прошлым кодом',
    parental_control_input_code: 'Введите PIN-код',
    parental_control_input_error: 'Вы ввели неправильный PIN-код',


    torent_nohash_reasons: 'Причины',
    torent_nohash_reason_one: 'TorServer не смог скачать торрент файл',
    torent_nohash_reason_two: 'Ответ от TorServer',
    torent_nohash_reason_three: 'Ссылка',
    torent_nohash_do: 'Что делать?',
    torent_nohash_do_one: 'Проверьте правильно ли вы настроили Jackett',
    torent_nohash_do_two: 'Приватные источники могут не выдавать ссылку на файл',
    torent_nohash_do_three: 'Убедитесь что Jackett тоже может скачать файл',
    torent_nohash_do_four: 'Написать в нашу Telegram-группу: @lampa_group',
    torent_nohash_do_five: 'Укажите какой фильм, какая раздача и по возможности фото этой раздачи',

    torrent_error_text: 'Не удалось подключиться к TorrServer. Давайте быстро пройдёмся по списку возможных проблем и всё проверим.',
    torrent_error_step_1: 'Запущен ли TorrServer',
    torrent_error_step_2: 'Динамический IP-адрес',
    torrent_error_step_3: 'Протокол и порт',
    torrent_error_step_4: 'Блокировка антивирусами',
    torrent_error_step_5: 'Проверьте на доступность',
    torrent_error_step_6: 'Все равно не работает',
    torrent_error_info_1: 'Убедитесь, что вы запустили TorrServer на устройстве, где он установлен.',
    torrent_error_info_2: 'Частая ошибка, изменился IP-адрес устройства с TorrServer. Убедитесь, что IP-адрес, который вы ввели - {ip}, совпадает с адресом устройства, на котором установлен TorrServer.',
    torrent_error_info_3: 'Для подключения к TorrServer, необходимо указать протокол http:// в начале и порт :8090 в конце адреса. Убедитесь, что после IP-адреса указан порт, ваш текущий адрес - {ip}',
    torrent_error_info_4: 'Частое явление, антивирус или брандмауэр может блокировать доступ по IP-адресу, попробуйте отключить антивирус и брандмауэр.',
    torrent_error_info_5: 'На любом другом устройстве в этой же сети, откройте в браузере адрес {ip} и проверьте, доступен ли веб-интерфейс TorrServer.',
    torrent_error_info_6: 'Если после всех проверок всё равно возникает ошибка подключения, попробуйте перезагрузить TorrServer и интернет-адаптер.',
    torrent_error_info_7: 'Если проблема не устранена, пишите в Telegram-группу @lampa_group с текстом (vi3000 не подключается к TorrServer после всех проверок, текущий адрес {ip})',
    torrent_error_start: 'Начать проверку',
    torrent_error_nomatrix: 'Не удалось подтвердить версию Matrix',
    torrent_error_made: 'Выполнено',
    torrent_error_from: 'из',
    torrent_error_next: 'Далее',
    torrent_error_complite: 'Завершить',
    torrent_error_connect: 'Ошибка подключения',
    torrent_error_check_no_auth: 'Сервер ответил на запрос, но не удалось пройти авторизацию',

    torrent_install_need: 'Необходим TorrServer',
    torrent_install_text: 'TorrServer – приложение, которое позволяет просматривать контент из торрент-файлов в онлайн режиме.<br><br>Более детальную информацию по установке вы найдете в Telegram-группах, указанных ниже.',
    torrent_install_contact: 'Telegram-группы',

    torrent_item_bitrate: 'Битрейт',
    torrent_item_seeds: 'Раздают',
    torrent_item_grabs: 'Качают',
    torrent_item_mb: 'Мбит/с',

    torrent_serial_episode: 'Серия',
    torrent_serial_season: 'Сезон',
    torrent_serial_date: 'Выход',

    torrent_get_magnet: 'Запрашиваю magnet ссылку',
    torrent_remove_title: 'Удалить',
    torrent_remove_descr: 'Торрент будет удален из вашего списка',

    torrent_parser_any_one: 'Любое',
    torrent_parser_any_two: 'Любой',
    torrent_parser_no_choice: 'Не выбрано',
    torrent_parser_yes: 'Да',
    torrent_parser_no: 'Нет',
    torrent_parser_quality: 'Качество',
    torrent_parser_subs: 'Субтитры',
    torrent_parser_voice: 'Перевод',
    torrent_parser_tracker: 'Трекер',
    torrent_parser_year: 'Год',
    torrent_parser_season: 'Сезон',
    torrent_parser_sort_by_seeders: 'По раздающим',
    torrent_parser_sort_by_size: 'По размеру',
    torrent_parser_sort_by_name: 'По названию',
    torrent_parser_sort_by_tracker: 'По источнику',
    torrent_parser_sort_by_date: 'По дате',
    torrent_parser_sort_by_viewed: 'По просмотренным',
    torrent_parser_voice_dubbing: 'Дубляж',
    torrent_parser_voice_polyphonic: 'Многоголосый',
    torrent_parser_voice_two: 'Двухголосый',
    torrent_parser_voice_amateur: 'Любительский',
    torrent_parser_reset: 'Сбросить фильтр',
    torrent_parser_empty: 'Не удалось получить результатов',
    torrent_parser_no_hash: 'Не удалось получить HASH, попробуйте перезагрузить TorrServer',
    torrent_parser_added_to_mytorrents: 'добавлено в «Мои торренты»',
    torrent_parser_add_to_mytorrents: 'Добавить в «Мои торренты»',
    torrent_parser_label_title: 'Пометить',
    torrent_parser_label_descr: 'Пометить раздачу с флагом (просмотрено)',
    torrent_parser_label_cancel_title: 'Снять отметку',
    torrent_parser_label_cancel_descr: 'Снять отметку с раздачи (просмотрено)',
    torrent_parser_timeout: 'Время ожидания истекло',
    torrent_parser_nofiles: 'Не удалось извлечь подходящие файлы',
    torrent_parser_set_link: 'Укажите ссылку для парсинга',
    torrent_parser_request_error: 'Ошибка в запросе',
    torrent_parser_magnet_error: 'Не удалось получить magnet ссылку',
    torrent_parser_no_responce: 'Парсер не отвечает на запрос',
    torrent_parser_torlook_fallback_search_notification: 'Парсер Jackett не доступен или настройки подключения не верны. Осуществляется поиск в Torlook...',

    about_text: 'Приложение полностью бесплатное и использует публичные ссылки для получения информации о видео, новинках, популярных фильмах и т.д. Вся доступная информация используется исключительно в познавательных целях, приложение не использует свои собственные серверы для распространения информации.',
    about_channel: 'Наш канал',
    about_group: 'Группа',
    about_version: 'Версия',
    about_donate: 'Донат',

    title_watched: 'Вы смотрели',
    title_settings: 'Настройки',
    title_collections: 'Подборки',
    title_company: 'Компания',
    title_actors: 'Актеры',
    title_actor: 'Актер',
    title_actress: 'Актриса',
    title_person: 'Персона',
    title_persons: 'Персоны',
    title_person_about: 'О персоне',
    title_comments: 'Комментарии',
    title_torrents: 'Торренты',
    title_trailers: 'Трейлеры',
    title_watch: 'Смотреть',
    title_error: 'Ошибка',
    title_links: 'Ссылки',
    title_choice: 'Выбрать',
    title_main: 'Главная',
    title_book: 'Закладки',
    title_like: 'Нравится',
    title_wath: 'Позже',
    title_look: 'Смотрю',
    title_scheduled: 'Запланировано',
    title_viewed: 'Просмотрено',
    title_thrown: 'Брошено',
    title_continued: 'Продолжение следует',
    title_history: 'История просмотров',
    title_mytorrents: 'Мои торренты',
    title_last: 'Последняя',
    title_action: 'Действие',
    title_producer: 'Режиссер',
    title_collection: 'Коллекция',
    title_recomendations: 'Рекомендации',
    title_similar: 'Похожие',
    title_about: 'О приложении',
    title_timetable: 'Расписание',
    title_relises: 'Цифровые релизы',
    title_catalog: 'Каталог',
    title_category: 'Категория',
    title_parser: 'Парсер',
    title_type: 'Тип',
    title_rating: 'Рейтинг',
    title_country: 'Страна',
    title_year: 'Год',
    title_genre: 'Жанр',
    title_filter: 'Фильтр',
    title_notice: 'Уведомления',
    title_files: 'Файлы',
    title_now_watch: 'Сейчас смотрят',
    title_latest: 'Последнее добавление',
    title_continue: 'Продолжить просмотр',
    title_recomend_watch: 'Рекомендуем посмотреть',
    title_new_episodes: 'Новые серии',
    title_popular: 'Популярное',
    title_popular_movie: 'Популярные фильмы',
    title_popular_tv: 'Популярные сериалы',
    title_new_this_year: 'Новинки этого года',
    title_hight_voite: 'С высоким рейтингом',
    title_new: 'Новинки',
    title_trend_day: 'Сегодня в тренде',
    title_trend_week: 'В тренде за неделю',
    title_upcoming: 'Смотрите в кинозалах',
    title_top_movie: 'Топ фильмы',
    title_top_tv: 'Топ сериалы',
    title_tv_today: 'Сегодня в эфире',
    title_this_week: 'На этой неделе',
    title_in_top: 'В топе',
    title_out: 'Выход',
    title_out_confirm: 'Да, выйти',
    title_continue_two: 'Продолжить',
    title_choice_language: 'Выбрать язык',
    title_subscribe: 'Подписаться',
    title_subscribes: 'Подписки',
    title_unsubscribe: 'Отписаться',
    title_language: 'Язык оригинала',
    title_language_short: 'Язык',
    title_ongoing: 'Онгоинги',
    title_pgrating: 'Возрастное ограничение',
    title_card: 'Карточка',
    title_seasons: 'Сезоны',
    title_episodes: 'Серии',
    title_rewiews: 'Отзывы',
    title_channel: 'Канал',
    title_in_high_quality: 'В высоком качестве',
    title_author: 'Автор',
    title_buffer: 'Буфер',
    title_upcoming_episodes: 'Ближайшие выходы эпизодов',
    title_recent_episodes: 'Недавние выходы эпизодов',
    title_reactions: 'Реакции',
    title_last_year: 'Прошлый год',
    title_reset: 'Перезагрузить',
    title_left:'Осталось',
    title_parental_control: 'Родительский контроль',
    title_worth_rewatch: 'Стоит пересмотреть',
    title_fire: 'Огонь!',
    title_top_100: 'Топ 100',
    title_ai_assistant: 'AI-ассистент',
    title_facts: 'Интересные факты',
    title_anons: 'Анонс',
    title_developer: 'Разработчик',
    title_navigation: 'Навигация',
    title_page: 'Страница',
    title_channels: 'Каналы',
    title_best_of_2000: 'Золотые 2000-е',
    title_best_of_2010: 'Хиты 2010-х',
    title_best_of_2015: 'Современная классика',
    title_comedy_of_2000: 'Смех 2000-х',
    title_comedy_of_2010: 'Юмор 2010-х',
    title_comedy_of_2015: 'Современные комедии',

    reactions_none: 'Нет реакций',
    reactions_fire: 'Супер',
    reactions_nice: 'Неплохо',
    reactions_think: 'Смотрибельно',
    reactions_bore: 'Скука',
    reactions_shit: 'Плохо',
    reactions_ready: 'Вы уже оставили реакцию',

    subscribe_success: 'Вы успешно подписались',
    subscribe_error: 'Возникла ошибка при подписке, попробуйте позже',
    subscribe_noinfo: 'Не удалось получить информацию, попробуйте позже',
    subscribe_info: 'В разделе (Подписки) у вас будут отображаться все ваши подписки на переводы. Когда выйдет новая серия с выбранным переводом, вы получите уведомление.',

    company_headquarters: 'Штаб',
    company_homepage: 'Сайт',
    company_country: 'Страна',

    country_ad: 'Андорра',
    country_ae: 'ОАЭ',
    country_af: 'Афганистан',
    country_al: 'Албания',
    country_am: 'Армения',
    country_ao: 'Ангола',
    country_ar: 'Аргентина',
    country_at: 'Австрия',
    country_au: 'Австралия',
    country_aw: 'Аруба',
    country_az: 'Азербайджан',
    country_bа: 'Босния и Герцеговина',
    country_bd: 'Бангладеш',
    country_be: 'Бельгия',
    country_bg: 'Болгария',
    country_bh: 'Бахрейн',
    country_bi: 'Бурунди',
    country_bj: 'Бенин',
    country_bo: 'Боливия',
    country_br: 'Бразилия',
    country_bs: 'Багамские о-ва',
    country_bt: 'Бутан',
    country_bw: 'Ботсвана',
    country_by: 'Беларусь',
    country_ca: 'Канада',
    country_ch: 'Швейцария',
    country_cl: 'Чили',
    country_cm: 'Камерун',
    country_cn: 'Китай',
    country_co: 'Колумбия',
    country_cr: 'Коста-Рика',
    country_cu: 'Куба',
    country_cv: 'Кабо-Верде',
    country_cy: 'Кипр',
    country_cz: 'Чехия',
    country_de: 'Германия',
    country_dj: 'Джибути',
    country_dk: 'Дания',
    country_do: 'Доминикана',
    country_dz: 'Алжир',
    country_ec: 'Эквадор',
    country_ee: 'Эстония',
    country_eg: 'Египет',
    country_es: 'Испания',
    country_et: 'Эфиопия',
    country_fi: 'Финляндия',
    country_fo: 'Фарерские о-ва',
    country_fr: 'Франция',
    country_ga: 'Габон',
    country_gb: 'Великобритания',
    country_ge: 'Грузия',
    country_gh: 'Гана',
    country_gl: 'Гренландия',
    country_gp: 'Гваделупа',
    country_gr: 'Греция',
    country_gt: 'Гватемала',
    country_hk: 'Гонконг',
    country_hr: 'Хорватия',
    country_ht: 'Гаити',
    country_hu: 'Венгрия',
    country_id: 'Индонезия',
    country_ie: 'Ирландия',
    country_il: 'Израиль',
    country_in: 'Индия',
    country_iq: 'Ирак',
    country_ir: 'Иран',
    country_is: 'Исландия',
    country_it: 'Италия',
    country_jm: 'Ямайка',
    country_jo: 'Иордания',
    country_jp: 'Япония',
    country_ke: 'Кения',
    country_kg: 'Киргизия',
    country_kh: 'Камбоджа',
    country_kp: 'Северная Корея',
    country_kr: 'Южная Корея',
    country_kz: 'Казахстан',
    country_kw: 'Кувейт',
    country_la: 'Лаос',
    country_lb: 'Ливан',
    country_li: 'Лихтенштейн',
    country_lk: 'Шри-Ланка',
    country_lr: 'Либерия',
    country_lt: 'Литва',
    country_lu: 'Люксембург',
    country_lv: 'Латвия',
    country_ly: 'Ливия',
    country_ma: 'Марокко',
    country_mc: 'Монако',
    country_md: 'Молдова',
    country_me: 'Черногория',
    country_mk: 'Македония',
    country_mm: 'Мьянма',
    country_mn: 'Монголия',
    country_mo: 'Макао',
    country_mt: 'Мальта',
    country_mu: 'Маврикий',
    country_mv: 'Мальдивы',
    country_mw: 'Малави',
    country_mx: 'Мексика',
    country_my: 'Малайзия',
    country_mz: 'Мозамбик',
    country_na: 'Намибия',
    country_ne: 'Нигер',
    country_ng: 'Нигерия',
    country_ni: 'Никарагуа',
    country_nl: 'Нидерланды',
    country_no: 'Норвегия',
    country_np: 'Непал',
    country_nz: 'Новая Зеландия',
    country_om: 'Оман',
    country_pa: 'Панама',
    country_pe: 'Перу',
    country_pg: 'Папуа - Новая Гвинея',
    country_ph: 'Филиппины',
    country_pk: 'Пакистан',
    country_pl: 'Польша',
    country_pr: 'Пуэрто-Рико',
    country_ps: 'Палестина',
    country_pt: 'Португалия',
    country_py: 'Парагвай',
    country_qa: 'Катар',
    country_ro: 'Румыния',
    country_rs: 'Сербия',
    country_ru: 'Россия',
    country_rw: 'Руанда',
    country_sa: 'Саудовская Аравия',
    country_sd: 'Судан',
    country_se: 'Швеция',
    country_sg: 'Сингапур',
    country_si: 'Словения',
    country_sk: 'Словакия',
    country_sn: 'Сенегал',
    country_su: 'СССР',
    country_sv: 'Сальвадор',
    country_sy: 'Сирия',
    country_th: 'Таиланд',
    country_tj: 'Таджикистан',
    country_tm: 'Туркменистан',
    country_tn: 'Тунис',
    country_tr: 'Турция',
    country_tw: 'Тайвань',
    country_tz: 'Танзания',
    country_ua: 'Украина',
    country_ug: 'Уганда',
    country_us: 'США',
    country_uy: 'Уругвай',
    country_uz: 'Узбекистан',
    country_ve: 'Венесуэла',
    country_vn: 'Вьетнам',
    country_ws: 'Самоа',
    country_xk: 'Косово',
    country_ye: 'Йемен',
    country_yu: 'Югославия',
    country_za: 'ЮАР',
    country_zm: 'Замбия',
    country_zw: 'Зимбабве',

    filter_clarify: 'Уточнить',
    filter_clarify_two: 'Уточнить поиск',
    filter_set_name: 'Указать название',
    filter_sorted: 'Сортировать',
    filter_filtred: 'Фильтр',
    filter_any: 'Любой',
    filter_combinations: 'Комбинации',
    filter_alt_names: 'Другие названия',
    filter_rating_from: 'от',
    filter_rating_to: 'до',

    filter_lang_af: 'Африкаанс',
    filter_lang_ar: 'Арабский',
    filter_lang_az: 'Азербайджанский',
    filter_lang_ba: 'Башкирский',
    filter_lang_be: 'Белорусский',
    filter_lang_bg: 'Болгарский',
    filter_lang_bn: 'Бенгальский',
    filter_lang_bs: 'Боснийский',
    filter_lang_ca: 'Каталанский',
    filter_lang_ce: 'Чеченский',
    filter_lang_cs: 'Чешский',
    filter_lang_da: 'Датский',
    filter_lang_de: 'Немецкий',
    filter_lang_el: 'Греческий',
    filter_lang_en: 'Английский',
    filter_lang_es: 'Испанский',
    filter_lang_et: 'Эстонский',
    filter_lang_fa: 'Персидский',
    filter_lang_fi: 'Финский',
    filter_lang_fr: 'Французский',
    filter_lang_ga: 'Ирландский',
    filter_lang_gl: 'Галисийский',
    filter_lang_gn: 'Гуарани',
    filter_lang_he: 'Иврит',
    filter_lang_hi: 'Хинди',
    filter_lang_hr: 'Хорватский',
    filter_lang_hu: 'Венгерский',
    filter_lang_hy: 'Армянский',
    filter_lang_id: 'Индонезийский',
    filter_lang_is: 'Исландский',
    filter_lang_it: 'Итальянский',
    filter_lang_ja: 'Японский',
    filter_lang_ka: 'Грузинский',
    filter_lang_kk: 'Казахский',
    filter_lang_ko: 'Корейский',
    filter_lang_ks: 'Кашмири',
    filter_lang_ku: 'Курдский',
    filter_lang_ky: 'Киргизский',
    filter_lang_lt: 'Литовский',
    filter_lang_lv: 'Латышский',
    filter_lang_mi: 'Маори',
    filter_lang_mk: 'Македонский',
    filter_lang_mn: 'Монгольский',
    filter_lang_mt: 'Мальтийский',
    filter_lang_ne: 'Непальский',
    filter_lang_nl: 'Нидерландский',
    filter_lang_no: 'Норвежский',
    filter_lang_pa: 'Панджаби',
    filter_lang_pl: 'Польский',
    filter_lang_ps: 'Пушту',
    filter_lang_pt: 'Португальский',
    filter_lang_ro: 'Румынский',
    filter_lang_ru: 'Русский',
    filter_lang_si: 'Сингальский',
    filter_lang_sk: 'Словацкий',
    filter_lang_sl: 'Словенский',
    filter_lang_sm: 'Самоанский',
    filter_lang_so: 'Сомалийский',
    filter_lang_sq: 'Албанский',
    filter_lang_sr: 'Сербский',
    filter_lang_sv: 'Шведский',
    filter_lang_sw: 'Суахили',
    filter_lang_ta: 'Тамильский',
    filter_lang_tg: 'Таджикский',
    filter_lang_th: 'Тайский',
    filter_lang_tk: 'Туркменский',
    filter_lang_tr: 'Турецкий',
    filter_lang_tt: 'Татарский',
    filter_lang_ur: 'Урду',
    filter_lang_uk: 'Украинский',
    filter_lang_uz: 'Узбекский',
    filter_lang_vi: 'Вьетнамский',
    filter_lang_yi: 'Идиш',
    filter_lang_zh: 'Китайский',

    filter_genre_ac: 'Боевик',
    filter_genre_ad: 'Приключения',
    filter_genre_mv: 'Мультфильм',
    filter_genre_cm: 'Комедия',
    filter_genre_cr: 'Криминал',
    filter_genre_dc: 'Документальный',
    filter_genre_dr: 'Драма',
    filter_genre_fm: 'Семейный',
    filter_genre_fe: 'Фэнтези',
    filter_genre_hi: 'История',
    filter_genre_ho: 'Ужасы',
    filter_genre_mu: 'Музыка',
    filter_genre_de: 'Детектив',
    filter_genre_md: 'Мелодрама',
    filter_genre_fa: 'Фантастика',
    filter_genre_tv: 'Телевизионный фильм',
    filter_genre_tr: 'Триллер',
    filter_genre_mi: 'Военный',
    filter_genre_ve: 'Вестерн',
    filter_genre_aa: 'Боевик и Приключения',
    filter_genre_ch: 'Детский',
    filter_genre_nw: 'Новости',
    filter_genre_rs: 'Реалити-шоу',
    filter_genre_hf: 'НФ и Фэнтези',
    filter_genre_op: 'Мыльная опера',
    filter_genre_tc: 'Ток-шоу',
    filter_genre_mp: 'Война и Политика',

    filter_keyword_sequel: 'Сиквел',
    filter_keyword_based_comic: 'По комиксам',
    filter_keyword_space: 'Космос',
    filter_keyword_survival: 'Выживание',
    filter_keyword_zombie: 'Зомби',
    filter_keyword_school: 'Школа',
    filter_keyword_revenge: 'Месть',
    filter_keyword_detective: 'Детектив',
    filter_keyword_robots: 'Роботы',
    filter_keyword_vampires: 'Вампиры',
    filter_keyword_aliens: 'Инопланетяне',
    filter_keyword_police: 'Полиция',
    filter_keyword_reincarnation: 'Перерождение',
    filter_keyword_spy: 'Шпион',
    filter_keyword_disaster: 'Катастрофа',
    filter_keyword_christmas: 'Рождество',

    empty_title: 'Пусто',
    empty_text: 'По вашему фильтру ничего не нашлось, уточните фильтр.',
    empty_title_two: 'Здесь пусто',
    empty_text_two: 'На данный момент список пустой',

    empty_subscribes_title: 'Ваши подписки на переводы',
    empty_subscribes_text: 'Просто подпишитесь на любимый перевод и мы будем уведомлять вас о выходе новой серии.',
    empty_history_title: 'Ваша история просмотров',
    empty_history_text: 'Здесь будет отображаться ваша история просмотров.',
    empty_bookmark_title: 'Ваше избранное',
    empty_bookmark_text: 'Добавляйте в избранное понравившиеся фильмы и сериалы, чтобы быстро находить их в этом разделе.',
    empty_mytorrents_title: 'Ваши торренты',
    empty_mytorrents_text: 'Здесь будут отображаться загруженные вами торренты через TorServer.',

    back_to_card: 'Вернуться в карточку',

    menu_main: 'Главная',
    menu_movies: 'Фильмы',
    menu_tv: 'Сериалы',
    menu_catalog: 'Каталог',
    menu_filter: 'Фильтр',
    menu_collections: 'Подборки',
    menu_relises: 'Релизы',
    menu_anime: 'Аниме',
    menu_bookmark: 'Закладки',
    menu_like: 'Нравится',
    menu_time: 'Позже',
    menu_history: 'История',
    menu_timeline: 'Расписание',
    menu_torrents: 'Торренты',
    menu_settings: 'Настройки',
    menu_about: 'Информация',
    menu_console: 'Консоль',
    menu_multmovie: 'Мультфильмы',
    menu_multtv: 'Мультсериалы',
    menu_feed: 'Лента',

    lampa_movie_title: 'Ламповое кино',
    lampa_movie_descr: 'Следите за новинками на своем смартфоне. <br>Телеграм: <b>@lampa_movie</b>',

    plugins_catalog_work: 'Рабочие плагины',
    plugins_catalog_work_descr: 'Плагины, которые точно работают в лампе.',
    plugins_catalog_popular: 'Популярные плагины среди пользователей',
    plugins_catalog_popular_descr: 'Установка из неизвестных источников может привести к некорректной работе приложения.',
    plugins_online: 'Просмотр онлайн',
    plugins_check_fail: 'Не удалось проверить работоспособность плагина. Однако это не означает, что плагин не работает. Перезагрузите приложение для выяснения, загружается ли плагин.',
    plugins_need_reload: 'Для применения плагина необходимо перезагрузить приложение',
    plugins_install: 'Установить',
    plugins_install_ready: 'Этот плагин уже установлен.',
    plugins_installed: 'Установок',
    plugins_load_from: 'Загружено из CUB',
    plugins_ok_for_check: 'Нажмите (OK) для проверки плагина',
    plugins_no_loaded: 'При загрузке приложения, часть плагинов не удалось загрузить',
    plugins_remove: 'Удалить плагины',
    plugins_add_success: 'Плагин успешно подключен',

    time_viewed: 'Просмотрено',
    time_from: 'из',
    time_reset: 'Сбросить тайм-код',

    settings_clear_cache: 'Кеш и данные очищены',
    settings_clear_cache_only: 'Кеш очищен',
    settings_user_links: 'Пользовательская ссылка',
    settings_for_local: 'Для локального TorrServer',
    settings_add: 'Добавить',
    settings_remove: 'Удалить',
    settings_this_value: 'текущее значение',
    settings_added: 'Добавлено',
    settings_removed: 'Удалено',
    settings_reset: 'Сброс настроек',

    settings_param_player_inner: 'Встроенный',
    settings_param_player_outside: 'Внешний',
    settings_param_player_inner_tvos: 'Встроенный',
    settings_param_yes: 'Да',
    settings_param_no: 'Нет',
    settings_param_interface_size_small: 'Меньше',
    settings_param_interface_size_normal: 'Нормальный',
    settings_param_interface_size_bigger: 'Больше',
    settings_param_poster_quality_low: 'Низкое',
    settings_param_poster_quality_average: 'Среднее',
    settings_param_poster_quality_high: 'Высокое',
    settings_param_parse_directly: 'Напрямую',
    settings_param_parse_api: 'Через API сайта',
    settings_param_background_complex: 'Сложный',
    settings_param_background_simple: 'Простой',
    settings_param_background_image: 'Картинка',
    settings_param_link_use_one: 'Основную',
    settings_param_link_use_two: 'Дополнительную',
    settings_param_link_use_both: 'Обе',
    settings_param_subtitles_size_small: 'Маленькие',
    settings_param_subtitles_size_normal: 'Обычные',
    settings_param_subtitles_size_bigger: 'Большие',
    settings_param_screensaver_nature: 'Природа',
    settings_param_torrent_lang_orig: 'Оригинал',
    settings_param_player_timecode_again: 'Начать с начала',
    settings_param_player_timecode_continue: 'Продолжить',
    settings_param_player_timecode_ask: 'Спрашивать',
    settings_param_player_scale_method: 'Рассчитать',
    settings_param_player_hls_app: 'Системный',
    settings_param_player_hls_js: 'Программный',
    settings_param_card_view_load: 'Подгружать',
    settings_param_card_view_all: 'Показать все',
    settings_param_navigation_remote: 'Пульт',
    settings_param_navigation_mouse: 'Пульт с мышкой',
    settings_param_navigation_touch: 'Сенсор',
    settings_param_keyboard_lampa: 'Встроенная',
    settings_param_keyboard_system: 'Системная',
    settings_param_card_interface_old: 'Старый',
    settings_param_card_interface_new: 'Новый',

    settings_param_glass_easy: 'Прозрачная',
    settings_param_glass_medium: 'Полупрозрачная',
    settings_param_glass_blacked: 'Затемнённая',

    settings_param_jackett_interview_all: 'Все',
    settings_param_jackett_interview_healthy: 'Только доступные',
    settings_parser_jackett_interview: 'Опрашивать трекеры',

    helper_keyboard: 'После ввода значения нажмите кнопку «Назад» для сохранения',
    helper_torrents: 'Удерживайте клавишу (ОК) для вызова контекстного меню',
    helper_cleared: 'Успешно, подсказки будут показаны заново.',
    helper_torrents_view: 'Для сброса тайм-кода и вызова меню удерживайте клавишу (ОК)',

    fav_sync_title: 'Синхронизация закладок',
    fav_sync_text: 'Ваши любимые закладки вместе с Вами. Подключите синхронизацию и просматривайте на любом устройстве. <br><br>Для этого зарегистрируйтесь на сайте {site}, создайте профиль и авторизуйтесь в приложение.',
    fav_sync_site: 'Сайт',
    fav_remove_title: 'Удалить из истории',
    fav_remove_descr: 'Удалить выделенную карточку',
    fav_clear_title: 'Очистить историю',
    fav_clear_descr: 'Удалить все карточки из истории',
    fav_clear_label_title: 'Очистить метки',
    fav_clear_label_descr: 'Очистить метки о просмотрах',
    fav_clear_time_title: 'Очистить тайм-коды',
    fav_clear_time_descr: 'Очистить все тайм-коды',
    fav_label_cleared: 'Отметки очищены',
    fav_time_cleared: 'Тайм-коды очищены',

    timetable_empty: 'В этом разделе будут отображаться даты выхода новых серий',

    player_quality: 'Качество',

    player_quality_premium: 'По подписке',
    player_flow: 'Поток',
    player_tracks: 'Аудиодорожки',
    player_disabled: 'Отключено',
    player_unknown: 'Неизвестно',
    player_subs: 'Субтитры',
    player_size_default_title: 'По умолчанию',
    player_size_default_descr: 'Размер видео по умолчанию',
    player_size_cover_title: 'Расширить',
    player_size_cover_descr: 'Расширяет видео на весь экран',
    player_size_fill_title: 'Заполнить',
    player_size_fill_descr: 'Вместить видео на весь экран',
    player_size_s115_title: 'Увеличить 115%',
    player_size_s115_descr: 'Увеличить видео на 115%',
    player_size_s130_title: 'Увеличить 130%',
    player_size_s130_descr: 'Увеличить видео на 130%',
    player_size_v115_title: 'По вертикали 115%',
    player_size_v115_descr: 'Увеличить видео на 115%',
    player_size_v130_title: 'По вертикали 130%',
    player_size_v130_descr: 'Увеличить видео на 130%',
    player_video_size: 'Размер видео',
    player_playlist: 'Плейлист',
    player_error_one: 'Не удалось декодировать видео',
    player_error_two: 'Видео не найдено или повреждено',
    player_start_from: 'Продолжить просмотр с',
    player_not_found: 'Плеер не найден',
    player_lauch: 'Запустить плеер',
    player_speed_default_title: 'Обычная',
    player_speed_two_descr: 'Воспроизводиться без звука',
    player_video_speed: 'Скорость воспроизведения',
    player_share_title: 'Поделиться',
    player_share_descr: 'Запустить это видео на другом устройстве',
    player_normalization_power_title: 'Сила нормализации',
    player_normalization_smooth_title: 'Скорость нормализации',
    player_normalization_step_none: 'Нулевая',
    player_normalization_step_low: 'Низкое',
    player_normalization_step_medium: 'Среднее',
    player_normalization_step_hight: 'Высокое',
    player_normalization: 'Нормализация',
    player_normalization_type_title: 'Тип нормализации',
    player_normalization_type_all: 'Все',
    player_normalization_type_up: 'Только повышение',
    player_normalization_type_down: 'Только понижение',
    player_youtube_no_played: 'К сожалению, это видео не доступно в вашем регионе, возможно, оно было заблокировано или удалено.',
    player_youtube_start_play: 'Для начала проигрывания видео, нажмите кнопку "Плей"',
    player_youtube_no_support: 'Ваше устройство не поддерживает воспроизведение YouTube видео, проверьте интернет соединение.',
    player_segments_title: 'Сегменты',
    player_segments_descr: 'Пропуск интро и другие части видео',
    player_segments_ad_title: 'Рекламные вставки',
    player_segments_skip_title: 'Интро и другое',
    player_segments_value_none: 'Не пропускать',
    player_segments_value_auto: 'Автопропуск',
    player_segments_value_user: 'Пользовательский',
    player_segments_skiped: 'Cегмент пропущен',

    broadcast_open: 'Открыть карточку на другом устройстве',
    broadcast_play: 'Выберите устройство для просмотра',

    card_new_episode: 'Новая серия',
    card_book_remove: 'Убрать из закладок',
    card_book_add: 'В закладки',
    card_book_descr: 'Смотрите в меню (Закладки)',
    card_like_remove: 'Убрать из понравившихся',
    card_like_add: 'Нравится',
    card_like_descr: 'Смотрите в меню (Нравится)',
    card_wath_remove: 'Убрать из ожидаемых',
    card_wath_add: 'Смотреть позже',
    card_wath_descr: 'Смотрите в меню (Позже)',
    card_history_remove: 'Убрать из истории',
    card_history_add: 'В историю',
    card_history_descr: 'Смотрите в меню (История)',

    keyboard_listen: 'Говорите, я слушаю...',
    keyboard_nomic: 'Нет доступа к микрофону',

    notice_new_quality: 'Доступно новое качество',
    notice_quality: 'Качество',
    notice_new_episode: 'Новая серия',
    notice_none: 'У вас еще нет никаких уведомлений, зарегистрируйтесь на сайте <b>{site}</b>, чтобы следить за новыми сериями и релизами.',
    notice_in_quality: 'В качестве',
    notice_none_account: 'У вас еще нет никаких уведомлений, добавьте сериалы в закладки и ожидайте уведомления о новых сериях.',
    notice_none_system: 'На данный момент у вас отсутствуют уведомления. Мы обязательно оповестим вас, когда появятся новые уведомления.',

    copy_link: 'Копировать ссылку на видео',
    copy_secuses: 'Ссылка скопирована в буфер обмена',
    copy_error: 'Ошибка при копирование ссылки',
    copy_link_buffer: 'Скопировать ссылку',

    account_sync_to_profile: 'Все закладки будут перенесены в профиль',
    account_sync_secuses: 'Все закладки успешно перенесены',
    account_profiles: 'Профили',
    account_profiles_empty: 'Не удалось получить список профилей',
    account_authorized: 'Авторизованы',
    account_logged_in: 'Вы вошли под аккаунтом',
    account_login_failed: 'Вход не выполнен',
    account_login_wait: 'Ожидаем входа в аккаунт',
    account_profile_main: 'Общий',
    account_profile_child: 'Детский',
    account_profile_add: 'Добавить профиль',
    account_profile_name: 'Имя профиля',
    account_profile_created: 'Профиль успешно создан',
    account_profile_limited: 'Достигнут максимальный лимит профилей: {count}',
    account_profile_info: 'Вы можете управлять профилями в настройках аккаунта, для этого перейдите на сайт <span class="account-modal__site">{site}/profiles</span>',
    account_export_secuses: 'Экспорт успешно завершён',
    account_export_fail: 'Ошибка при экспорте',
    account_export_fail_500: 'Неизвестная ошибка',
    account_export_fail_610: 'Вы исчерпали лимит на сегодня',
    account_export_fail_200: 'Ошибка базы данных, попробуйте позже',
    account_export_fail_600: 'Ошибка, не удалось загрузить файл',
    account_export_fail_620: 'Ошибка, файл не передан',
    account_import_secuses: 'Импорт успешно завершён',
    account_import_fail: 'Ошибка при импорте',
    account_imported: 'импортировано',
    account_reload_after: 'перезагрузка через 5 сек.',
    account_create: 'Откройте больше возможностей с аккаунтом CUB. Зарегистрируйтесь на сайте <span class="account-modal__site">{site}</span> и получите доступ к синхронизации ваших закладок, тайм-кодов и других возможностей аккаунта CUB.',
    account_premium: 'Раскройте новые горизонты с аккаунтом CUB Premium! Наслаждайтесь увеличенными лимитами и обогащенным функционалом сервиса. Перейдите на сайт <span class="account-modal__site">{site}/premium</span> и узнайте больше о преимуществах премиум аккаунта.',
    account_premium_more: 'Подробнее о CUB Premium',
    account_limited: 'Вы достигли максимального лимита. Увеличьте лимит с аккаунтом CUB Premium. Подробнее на сайте <span class="account-modal__site">{site}/premium</span>',
    account_premium_include_1: 'Увеличение количество закладок',
    account_premium_include_2: 'Увеличение истории просмотров',
    account_premium_include_3: 'Увеличение количество тайм-кодов',
    account_premium_include_4: 'Количество профилей на аккаунт',
    account_premium_include_5: 'Уведомления',
    account_premium_include_6: 'Синхронизация данных',
    account_premium_include_text_1: 'Больше закладок - больше возможностей! Сохраняйте свои любимые фильмы и сериалы, создавайте списки просмотра и наслаждайтесь просмотром в любое удобное время.',
    account_premium_include_text_2: 'Увеличьте историю просмотров в приложении и следите за тем, что уже посмотрели. Легко находите и пересматривайте свои любимые фильмы и сериалы.',
    account_premium_include_text_3: 'Не бойтесь пропустить ни одной важной сцены! Увеличьте количество тайм-кодов в приложении и легко отслеживайте, где остановились в просмотре любимых фильмов и сериалов.',
    account_premium_include_text_4: 'Получите больше свободы с нашим премиум доступом! Увеличьте количество профилей на аккаунте и позвольте своим друзьям и близким наслаждаться фильмами и сериалами вместе с вами. Никаких ограничений - наслаждайтесь просмотром с любимыми людьми.',
    account_premium_include_text_5: 'Не пропустите ни одной новой серии или перевода! Получайте уведомления вовремя и будьте в курсе всех обновлений. Увеличьте свой кинопоток вместе с нами и получайте уведомления о выходе новых серий и переводов прямо на свой смартфон.',
    account_premium_include_text_6: 'Синхронизуйте свои данные между устройствами с премиум доступом! Больше не нужно тратить время на поиск последнего эпизода, на котором вы остановились. С нашим премиум доступом вы можете синхронизировать свои данные между устройствами, чтобы продолжать просмотр с места, где вы остановились, на любом устройстве, где установлено приложение.',
    account_code_enter: 'Введите шестизначный код',
    account_code_error: 'Возможно, вы ввели неверный или устаревший код',
    account_code_wrong: 'Возможно, вы указали неверный формат',
    account_code_where: 'Перейдите на сайт <span class="account-add-device__site">{site}/add</span> и введите указанный там код.',
    account_code_input: 'Ввести код',
    account_qr_premium: 'Отсканируйте QR-код для оформления подписки',
    account_qr_code: 'Отсканируйте QR-код, чтобы перейти в бот',
    account_qr_create: 'Отсканируйте QR-код, чтобы создать аккаунт',
    account_add_device_title: 'Добавить устройство',
    account_add_device_text: 'Перейдите на сайт по ссылки <span class="account-modal__site">{site}/add</span> чтобы получить код для добавления устройства.',
    account_device_auth_needed: 'Для просмотра необходимо авторизоваться',
    account_device_go_to_bot: 'Перейдите в телеграм бот',
    account_device_select_devices: 'Устройства -> Добавить',
    account_device_enter_code: 'и введите этот код:',
    account_device_waiting: 'Ожидание авторизации...',
    account_device_code_expired: 'Код истёк. Попробуйте снова.',
    premium_need_title: 'Нужна подписка',
    premium_need_text: 'Для просмотра необходимо оформить подписку',
    premium_open_bot: 'Откройте телеграм бот',
    premium_tap_pay: 'и нажмите 💳 Подписка',
    premium_scan_qr: 'Отсканируйте QR-код, чтобы перейти в бот',
    account_none_title: 'Еще нет аккаунта?',
    account_none_include_1: 'Закладки и история просмотров сохраняются в облаке',
    account_none_include_2: 'Синхронизация между устройствами',
    account_none_include_3: 'Уведомления о новых сериях и релизах',
    account_none_include_4: 'Создание нескольких профилей на одном аккаунте',
    account_discuss_add_qr: 'Отсканируйте QR-код',
    account_discuss_add_title: 'Хотите оставить комментарий?',
    account_discuss_add_text: 'Отсканируйте QR-код, чтобы перейти в приложение и добавить комментарий к этому фильму или сериалу. <br><br> - Возьмите телефон или планшет <br> - Откройте камеру <br> - Наведите на QR-код <br> - Перейдите по ссылки, которая появится на экране',
    account_discuss_added: 'Спасибо за ваш комментарий!',
    account_discuss_added_ready: 'Вы уже оставили комментарий к этому фильму или сериалу.',


    network_noconnect: 'Нет подключения к сети',
    network_404: 'Запрошенная страница не найдена. [404]',
    network_401: 'Авторизация не удалась',
    network_500: 'Внутренняя ошибка сервера. [500]',
    network_parsererror: 'Запрошенный синтаксический анализ JSON завершился неудачно.',
    network_timeout: 'Время запроса истекло.',
    network_abort: 'Запрос был прерван.',
    network_error: 'Неизвестная ошибка',

    size_zero: '0 Байт',
    size_byte: 'Байт',
    size_kb: 'КБ',
    size_mb: 'МБ',
    size_gb: 'ГБ',
    size_tb: 'ТБ',
    size_pp: 'ПБ',

    speed_bit: 'бит/c',
    speed_kb: 'Кбит/c',
    speed_mb: 'Мбит/c',
    speed_gb: 'Гбит/c',
    speed_tb: 'Тбит/c',
    speed_pp: 'Пбит/c',

    month_1: 'Январь',
    month_2: 'Февраль',
    month_3: 'Март',
    month_4: 'Апрель',
    month_5: 'Ма',
    month_6: 'Июнь',
    month_7: 'Июль',
    month_8: 'Август',
    month_9: 'Сентябрь',
    month_10: 'Октябрь',
    month_11: 'Ноябрь',
    month_12: 'Декабрь',

    day_1: 'Понедельник',
    day_2: 'Вторник',
    day_3: 'Среда',
    day_4: 'Четверг',
    day_5: 'Пятница',
    day_6: 'Суббота',
    day_7: 'Воскресенье',

    month_1_e: 'Января',
    month_2_e: 'Февраля',
    month_3_e: 'Марта',
    month_4_e: 'Апреля',
    month_5_e: 'Мая',
    month_6_e: 'Июня',
    month_7_e: 'Июля',
    month_8_e: 'Августа',
    month_9_e: 'Сентября',
    month_10_e: 'Октября',
    month_11_e: 'Ноября',
    month_12_e: 'Декабря',

    week_1: 'Пн',
    week_2: 'Вт',
    week_3: 'Ср',
    week_4: 'Чт',
    week_5: 'Пт',
    week_6: 'Сб',
    week_7: 'Вс',

    time_h: 'ч.',
    time_m: 'м.',
    time_s: 'с.',

    extensions_enable: 'Включить',
    extensions_disable: 'Отключить',
    extensions_check: 'Проверить статус',
    extensions_install: 'Установить',
    extensions_info: 'Информация',
    extensions_edit: 'Редактировать',
    extensions_change_name: 'Изменить название',
    extensions_change_link: 'Изменить ссылку',
    extensions_remove: 'Удалить',
    extensions_set_name: 'Введите название плагина',
    extensions_set_url: 'Введите адрес плагина',
    extensions_ready: 'Этот плагин уже установлен',
    extensions_no_info: 'Без информации',
    extensions_no_name: 'Без названия',
    extensions_worked: 'Рабочий',
    extensions_no_plugin: 'Плагин не подтверждён ',
    extensions_add: 'Добавить плагин',
    extensions_from_memory: 'Установленные в память ',
    extensions_from_cub: 'Установленные из CUB',
    extensions_from_popular: 'Популярные плагины',
    extensions_from_lib: 'Библиотека плагинов',
    extensions_from_connected: 'Подключенные плагины',
    extensions_hpu_best: 'Популярные',
    extensions_hpu_recomend: 'Рекомендуем',
    extensions_hpu_theme: 'Темы',
    extensions_hpu_screensaver: 'Скринсейвер',
    extensions_hpu_video: 'Видео',
    extensions_hpu_control: 'Управление',
    extensions_hpu_other: 'Разное',
    extensions_hpu_: 'Остальное',

    speedtest_connect: 'подключение',
    speedtest_test: 'тестирование',
    speedtest_ready: 'готово',
    speedtest_button: 'Тестировать скорость',

    change_source_on_cub: 'Сменить источник на CUB',

    tv_status_returning_series: 'Онгоинг',
    tv_status_planned: 'Запланировано',
    tv_status_in_production: 'В производстве',
    tv_status_ended: 'Завершено',
    tv_status_canceled: 'Отменено',
    tv_status_pilot: 'Пилотный',
    tv_status_released:'Выпущенный',
    tv_status_rumored:'По слухам',
    tv_status_post_production:'Скоро',

    input_detection_touch: 'Хотите переключить на сенсорное управление?',
    input_detection_mouse: 'Хотите переключить на управление мышью?',
    input_detection_remote: 'Хотите переключить на управление пультом?',

    https_text: 'Вы используйте протокол HTTPS, c которым vi3000 работает некорректно. Для корректной работы приложения используйте адрес с протоколом HTTP',

    premiere_author_recomend_1: 'Закажите пиццу и готовьтесь к драйву.',
    premiere_author_recomend_2: 'Вечеринка только начинается.',
    premiere_author_recomend_3: 'Подготовьтесь к адреналину.',
    premiere_author_recomend_4: 'Готовы к незабываемому вечеру?',
    premiere_author_recomend_5: 'Рекомендую к просмотру.',
    premiere_title: 'Премьера',

    termsofuse_t_01: 'Правила использования',
    termsofuse_t_02: 'vi3000 - это удобный инструмент для ознакомления с новинками киноиндустрии, включая фильмы, сериалы, мультфильмы и другую информацию. Для получения информации о фильмах используется открытый источник - сайт themoviedb.org',
    termsofuse_t_03: 'Контент',
    termsofuse_t_04: 'vi3000 использует API (Application Programming Interface) от каталога themoviedb.org для получения информации о фильмах и телесериалах, а также для просмотра связанных с ними медиафайлов, таких как постеры, трейлеры и другое.',
    termsofuse_t_05: 'API от themoviedb.org позволяет приложению vi3000 получать доступ к базе данных фильмов и телесериалов, предоставляя возможность поиска медиафайлов и просмотра информации о них.',
    termsofuse_t_06: 'Взаимодействие между приложением vi3000 и themoviedb.org происходит через запросы к API, которые отправляются из приложения vi3000 на серверы themoviedb.org для получения информации и медиафайлов. Themoviedb.org обрабатывает запросы и отправляет обратно в приложение vi3000 запрошенные данные.',
    termsofuse_t_07: 'Таким образом, благодаря использованию API от themoviedb.org, приложение vi3000 предоставляет пользователям доступ к обширной базе данных фильмов и телесериалов, соблюдая при этом условия использования и ограничения, установленные правообладателем.',
    termsofuse_t_08: 'Расширения',
    termsofuse_t_09: 'Расширения - это мощный инструмент, предоставляемый для приложения vi3000, который позволяет пользователям расширить его возможности, добавить дополнительный функционал и изменить контент в соответствии с их потребностями.',
    termsofuse_t_10: 'Однако, следует отметить, что пользователи устанавливают расширения на свой страх и риск. Все последствия, возникающие в результате использования расширений, ложатся на пользователя. Пользователям рекомендуется быть осторожными при установке и использовании расширений, тщательно оценивая их надежность и безопасность.',
    termsofuse_t_11: 'Нарушения авторских прав',
    termsofuse_t_12: 'Если вы обнаружили нарушение авторских прав в приложении vi3000 - свяжитесь с разработчиками, используя раздел Контакты приложения. Однако, важно учесть, что приложение vi3000 использует API от каталога themoviedb.org, который предоставляет открытый доступ к информации о фильмах и сериалах. Это означает, что информация, которая отображается в приложении vi3000, является общедоступной и не нарушает авторских прав.',
    termsofuse_t_13: 'Если вы считаете, что в приложении vi3000 все же есть контент, нарушающий авторские права - обратитесь к правообладателю этого контента с просьбой удалить его со страниц сайта themoviedb.org. В свою очередь, приложение vi3000 может удалить контент при получении соответствующего уведомления о нарушении авторских прав.',

    install_app_apk_title: 'Как установить vi3000 на Android',
    install_app_apk_text: 'Мы заметили, что для запуска vi3000 на Android вы используете MediaStationX. Мы рекомендуем вам установить vi3000 в виде APK-приложения. Это обеспечит более стабильную работу и доступ ко всем функциям приложения. <br><br>Перейдите в группу <span class="account-modal__site">@lampa_group</span> в Телеграме, чтобы скачать последнюю версию APK и инструкции по установке.',
    install_app_apk_qr: 'Отсканируйте QR-код, чтобы скачать vi3000 APK',

    ad: 'Реклама',
    ad_disable: 'Отключите рекламу за 299 ₽ в месяц — оплата в Telegram.',
    ad_plugin: 'Реклама от плагина',
    ad_after: 'Реклама через',
    ad_skip: 'Пропустить',
    ad_continue_after: 'Просмотр начнется через',

    ad_fork_title: 'Как будете смотреть?',
    ad_fork_subtitle: 'Библиотека остаётся бесплатной. Выбор только про рекламу.',
    ad_fork_free_title: 'Бесплатно',
    ad_fork_free_text: 'Один ролик перед фильмом. Внутри — без прерываний.',
    ad_fork_free_btn: 'Смотреть с рекламой',
    ad_fork_paid_title: '299 ₽ в месяц',
    ad_fork_paid_text: 'Ни одного ролика. До 5 устройств на один аккаунт.',
    ad_fork_paid_day: 'Это 10 ₽ в день',
    ad_fork_paid_btn: 'Отключить рекламу',
    ad_fork_footer: 'Так мы оплачиваем серверы. Спасибо, что вы здесь.',
    ad_fork_note: 'Оплата в Telegram · без автосписаний · отключить можно в любой момент',
    ad_bar_text: '10 ₽ в день — и вы её больше не увидите',
    ad_not_now: 'Не сейчас',
    ad_turn_off: 'Отключить',
    ad_qr_title: 'Отключить рекламу',
    ad_qr_text: 'Наведите камеру телефона на QR-код — откроется наш Telegram-бот с оплатой.',
    ad_qr_close: 'Закрыть',
    subscription_activated: 'Подписка активна — реклама отключена',

    discuss_rules_title: 'Следуйте правилам и уважайте других — создаём комфорт вместе!',
    discuss_rules_rule_1: 'Не используйте слова, состоящие только из цифр.',
    discuss_rules_rule_2: 'Пишите на одном языке, используйте слова из 5 и более букв.',
    discuss_rules_rule_3: 'Используйте знаки препинания и завершайте предложения точками.',
    discuss_rules_rule_4: 'Избегайте непонятных символов !?#%',
    discuss_rules_rule_5: 'Пишите полные предложения, используйте предложение из 5 и более слов.',
    discuss_rules_rule_6: 'Не используйте слишком длинные слова.',
    discuss_rules_rule_7: 'Постарайтесь уместиться в 300 символов.',
    discuss_voited: 'Спасибо за вашу оценку! Ваш голос помогает улучшать контент.',

    confirm_open_player: 'Другое устройство запрашивает доступ к плееру. Хотите воспроизвести видео?',

    pincode_use_remote: 'Используйте пульт для ввода кода, нажимая стрелки для выбора нужной цифры.',
    pincode_use_toggle: 'Нажмите и удерживайте кнопку OK, чтобы сменить раскладку.',

    storage_quota_exceeded: 'Превышен лимит хранилища. Удалите кеш и повторите попытку.',

    ai_search_start_typing: 'Спросите у AI-ассистента, какие фильмы вы хотите найти. Например: "Фильмы про космос"',
    ai_search_limit: 'Лимит запросов превышен. Попробуйте повторить запрос позже. С подпиской CUB Premium лимиты будут увеличены, и вам не придется ждать!',
    ai_subscribe_title: 'Откройте бошьше возможностей с AI',
    ai_subscribe_descr: 'Оформите подписку CUB Premium и увеличте количество запросов к AI. Вместе с AI мы подберем вам лучшие фильмы которые только сможем.',

    dmca_title: 'Контент заблокирован',
    dmca_descr: 'Данный материал недоступен для просмотра. Он был заблокирован по просьбе правообладателя в соответствии с законодательством об авторских правах.',
    dmca_title_lgbt: 'Контент ограничен',
    dmca_descr_lgbt: 'Просмотр недоступен в вашем регионе, так как возможно содержит ЛГБТ-контент. В некоторых странах такие материалы могут быть запрещены или ограничены.',

    loading_progress_step_0: 'Подготовка',
    loading_progress_step_1: 'Загрузка языков',
    loading_progress_step_2: 'Поиск зеркал',
    loading_progress_step_3: 'Подготовка расширений',
    loading_progress_step_4: 'Осталось немного',
    loading_progress_step_5: 'Уже скоро',

    install_extension_rule_1: 'Установка стороннего плагина',
    install_extension_rule_2: 'Плагины создаются независимыми разработчиками, и VI3000 не проверяет их содержимое. Устанавливая их, вы соглашаетесь с тем, что:',
    install_extension_rule_3: '- Некоторые плагины могут запрашивать доступ к вашим данным или работать с непроверенными источниками.',
    install_extension_rule_4: '- Если устанавливаемый вами плагин нарушает авторские права или другие законы, вся ответственность за его использование лежит на вас.',
    install_extension_rule_5: '- Устанавливайте только плагины из доверенных источников. Если вы сомневаетесь в безопасности или законности плагина, лучше откажитесь от его установки.',
    install_extension_rule_6: 'VI3000 не поддерживает и не одобряет плагины, связанные с пиратским контентом.',
    install_extension_rule_7: 'Продолжая, вы подтверждаете, что понимаете эти риски.',

    terminal_title: 'Терминал',
    terminal_no_access: 'Без доступа',
    terminal_confirm: 'Разрешить',
    terminal_deny: 'Запретить',
    terminal_update: 'Обновить',
    terminal_code: 'Код доступа',
    terminal_text: 'Вы запрашиваете доступ к терминалу. Разработчики могут получить доступ к вашему устройству и управлять им. Это может быть полезно для диагностики и устранения проблем, но также может представлять риск безопасности. Пожалуйста, убедитесь, что вы доверяете разработчикам, прежде чем предоставлять доступ. <br><br>Вы можете в любой момент отключить эту функцию нажав на кнопку "Запретить".',

    developer_param_enabled: 'Режим разработчика',
    developer_param_nopremium: 'Отключить CUB Premium',
    developer_param_nodemo: 'Отключить демонстрационный режим',
    developer_param_ads: 'Показывать рекламу',
    developer_param_fps: 'Показывать FPS',

    developer_trigger_help_1: 'Почти догадались :)',
    developer_trigger_help_2: 'Еще немного :)',
    developer_trigger_help_3: 'Точно хочешь войти в режим разработчика?',
    developer_trigger_help_4: 'Режим разработчика активирован',

    remote_helper_long: 'Удерживайте кнопку (ОК) для вызова меню',
    no_watch_history: 'Нет истории просмотра',

    // todo:
    adult_content_title: 'Взрослый контент',
    adult_content_text_warning: 'Контент может содержать материалы для взрослых, которые могут быть неуместны для некоторых зрителей.',
    adult_content_text_modal: 'Этот фильм или сериал помечен как содержащий взрослый контент. Для просмотра этого материала вам должно быть 18 лет или больше. Пожалуйста, подтвердите, что вы достигли совершеннолетия, чтобы продолжить просмотр.',

    adult_content_confirm: 'Мне 18 лет или больше',
    adult_content_deny: 'Мне меньше 18 лет',
}
